import { AF_FIELD, type WithContextualField } from '@autodromo/contextual-fields'

interface ConditionalImageWrapperProps<T = object> extends WithContextualField {
  image: {
    render: (props: T) => JSX.Element | null
    props: T
  }
  href?: string
  openInNewTab?: boolean
  children?: never
}

export const ConditionalImageWrapper = <T = object>({
  image,
  href,
  openInNewTab,
  ...contextual
}: ConditionalImageWrapperProps<T>) => {
  const renderImage = () => {
    return typeof image !== 'string' && image?.render({ 
      ...image.props, 
      className: 'image',
      [AF_FIELD]: contextual[AF_FIELD]
    })
  }

  if (!href?.length) {
    return renderImage()
  }

  return (
    <a href={href} target={openInNewTab ? '_blank' : '_self'}>
      {renderImage()}
    </a>
  )
}
